import React from 'react';
import {
  StudentStatusEnum,
  studentType,
} from '../../../constants/types/student-type';
import TextWinds from '../../common/TextWinds';
import StudentConroller from './StudentController';
import Buttons from '../../common/Buttons2';
import {
  CheckBadgeIcon,
  TrashIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import { UserMinusIcon } from '@heroicons/react/20/solid';

interface StudentStateControlProps {
  status: StudentStatusEnum;
  studentList: studentType[];
  reloadTable: () => void;
  controller: StudentConroller;
}
const StudentStateControl = ({
  status,
  studentList,
  controller,
}: StudentStateControlProps) => {
  return (
    <div>
      <div className="flex justify-end gap-x-[22px] py-2">
        <div className="flex items-center gap-x-3">
          <TextWinds type="content_body4" color="gray7" className="w-[68px]">
            {studentList.length}명 선택됨
          </TextWinds>
        </div>
        <div className="flex gap-x-2">
          {status === StudentStatusEnum.ACTIVE && (
            <Buttons
              variant="outlined"
              color="red5"
              type="secondary"
              className="group whitespace-nowrap text-sm"
              onClick={() => controller.assignHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <UserGroupIcon className="mr-2 h-5 w-5 shrink-0 text-red-500 group-hover:text-white" />
              반 배정
            </Buttons>
          )}
          {status === StudentStatusEnum.ACTIVE && (
            <Buttons
              variant="filled"
              color="orange4"
              type="secondary"
              className="whitespace-nowrap text-sm"
              onClick={() => controller.stopHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <UserMinusIcon className="mr-2 h-5 w-5 shrink-0 text-white" />
              수강 정지
            </Buttons>
          )}
          {(status === StudentStatusEnum.INACTIVE ||
            status === StudentStatusEnum.PENDING) && (
            <Buttons
              variant="filled"
              color="purple5"
              type="secondary"
              className="whitespace-nowrap text-sm"
              onClick={() => controller.registHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <CheckBadgeIcon className="mr-2 h-5 w-5 shrink-0 text-white" />
              수강 등록
            </Buttons>
          )}
          {(status === StudentStatusEnum.INACTIVE ||
            status === StudentStatusEnum.PENDING) && (
            <Buttons
              variant="outlined"
              color="red5"
              type="secondary"
              className="group whitespace-nowrap text-sm"
              onClick={() => controller.deleteHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <TrashIcon className="mr-2 h-5 w-5 shrink-0 text-red-500 group-hover:text-white" />
              학생 삭제
            </Buttons>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentStateControl;
